import { jsx as _jsx } from "react/jsx-runtime";
import InlineSelectField from '../../../formFields/inlineSelectField';
const InlineSelect = ({ definition, value, elmId, onChange, }) => {
    const options = definition.options.map(option => ({
        value: option.value,
        text: option.label,
    }));
    const handleChange = (newValue) => {
        let filterValue = null;
        if (definition.mode === 'multi') {
            filterValue =
                newValue === '' || (Array.isArray(newValue) && newValue.length === 0)
                    ? []
                    : newValue;
        }
        else {
            filterValue = newValue || '';
        }
        onChange(definition.name, filterValue);
    };
    return (_jsx(InlineSelectField, { fluid: true, elmId: `${elmId}_${definition.name}`, options: options, value: value || '', mode: definition.mode || 'single', onChange: handleChange, showAnyOption: true, anyOptionText: 'Any', hideWrapper: true }));
};
export default InlineSelect;
//# sourceMappingURL=inlineSelect.js.map